interface Part {
    text: string;
    highlight: boolean;
}

const SUFFIX_DIGITS_HIGHLIGHTED = 5;

export function getOrderNumberParts(number: string): Part[] {
    // Case 1: Starts with alphanumeric prefix ending in "_" (like R1_, R2_, etc.)
    const PREFIX_REGEXP = /^(R[0-9]+_)/;
    const prefixMatch = number.match(PREFIX_REGEXP);
    if (prefixMatch) {
        const idPrefix = prefixMatch[1];
        const remaining = number.replace(PREFIX_REGEXP, '');

        return [
            { text: idPrefix, highlight: true },
            ...getOrderNumberParts(remaining)
        ];
    }

    // Case 2: Ends with _digit (e.g., _1, _123)
    const suffixMatch = number.match(/_(\d+)$/);
    if (suffixMatch) {
        const suffix = suffixMatch[0]; // "_1"
        const base = number.slice(0, -suffix.length);
        const lastHighlighted = base.slice(-SUFFIX_DIGITS_HIGHLIGHTED); // n digits before "_1"
        const normal = number.slice(
            0,
            number.length - (lastHighlighted.length + suffix.length)
        );
        return [
            { text: normal, highlight: false },
            { text: lastHighlighted + suffix, highlight: true }
        ];
    }

    // Case 3: Default → highlight last n digits
    const lastHighlighted = number.slice(-SUFFIX_DIGITS_HIGHLIGHTED);
    const normal = number.slice(0, -SUFFIX_DIGITS_HIGHLIGHTED);
    return [
        { text: normal, highlight: false },
        { text: lastHighlighted, highlight: true }
    ];
}
